import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import CaptureArea from "../../Ocr/CaptureTextFromImage/CaptureArea";
import { getExtension } from "../../../../helpers/helper";
import { DataContext } from "../../../../home/pages/automs/autom/FlowConfiguration";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { useRecoilState } from "recoil";
import { activeAutom } from "../../../../recoil-store/recoil-state";

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       variableRender - variable render
 * @returns     Component
 * @author      ibrahim AKIN
 */
function GetText({
    actions,
    action,
    variables,
    setOpenVariable,
    variableRender,
}) {
    const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
    const [openCaptureArea, setOpenCaptureArea] = useState(false);
    const [fileName, setFileName] = useState("");
    const [upImg, setUpImg] = useState();
    const [value, setValue] = useState(0);
    const [cropImg, setCropImg] = useState("");
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.FIND-AND-CLICK.";

    function findScopeAction(nodes, mainNodes) {
        for (let node of nodes) {
            if ('children' in node) {
                findScopeAction(node.children, node);
            } else if (node.id === action.id) {
                if (mainNodes?.fields?.getSS || actions[mainNodes?.id]?.fields?.getSS) {
                    let getSSURL = actions[mainNodes?.id]?.fields?.getSS?.value?.length ? actions[mainNodes.id].fields.getSS.value : mainNodes.fields.getSS?.value
                    //let sameURL = actions[mainNodes?.id]?.fields?.sameURL.value?.length ? actions[mainNodes.id].fields?.sameURL.value : mainNodes.fields.sameURL?.value
                    setUpImg(getSSURL);
                    if (action.fields.destination?.value.x === 0 &&
                        action.fields.destination?.value.y === 0) {
                        action.fields.destination = { value: { x: 0, y: 0 } };
                        action.fields.source = { value: { x: 0, y: 0 } };
                        setImgCoordinate({ coordinates: [] });
                    }
                }
            }
        }
    }

    useEffect(() => {
        if (!action.fields.imgURL) {
            action.fields.imgURL = { value: "" };
        } else {
            setUpImg(action.fields.imgURL.value);
        }
        if (!action.fields.completedCrop) {
            action.fields.completedCrop = { value: [] };
        } else {
            setImgCoordinate({ coordinates: action.fields.completedCrop.value });
        }
        if (!action.fields.fileName) {
            action.fields.fileName = { value: "" };
        } else {
            setFileName(action.fields.fileName.value);
        }
        if (!action.fields.mediaSize) {
            action.fields.mediaSize = { value: { width: 0, height: 0, div: 0 } };
        }
        if (!action.fields.gridCrop) {
            action.fields.gridCrop = { value: [] };
        }
        if (!action.fields.source) {
            action.fields.source = {
                value: { width: 0, height: 0, x: 0, y: 0, id: "asdf" },
            };
        }
        if (!action.fields.cropImg) {
            action.fields.cropImg = { value: "" };
        } else {
            setCropImg(action.fields.cropImg.value);
        }
        if (!action.fields.imagePath) {
            action.fields.imagePath = { value: "" };
        }
        if (!action.fields.destination) {
            action.fields.destination = {value: {x: 0, y: 0}};
        }
        if (!action.fields.source) {
            action.fields.source = {value: {width: 0, height: 0, x: 0, y: 0, id: "asdf"}};
        }
        let items = JSON.parse(JSON.stringify(automDetail.items))
        findScopeAction(items);
    }, [action, variables, variableRender]);

    function resizeImage(url, width, height, x, y, arr) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const imageObj = new Image();
        // set canvas dimensions
        canvas.width = width;
        canvas.height = height;

        imageObj.onload = function () {
            context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);
            setCropImg(canvas.toDataURL());
        };
        imageObj.src = url;
    }

    //convert base64 to buffer byte array
    useEffect(() => {
        resizeImage(
            upImg,
            action.fields.completedCrop.value[0]?.width,
            action.fields.completedCrop.value[0]?.height,
            action.fields.completedCrop.value[0]?.x,
            action.fields.completedCrop.value[0]?.y
        );
        if (upImg) {
            action.fields.cropImg = {
                byteValue: cropImg,
                value: fileName,
                extension: getExtension(fileName),
                type: "FILE",
            };

            action.fields.imagePath = action.fields.cropImg

        }
    }, [
        action.fields,
        upImg,
        setOpenCaptureArea,
        openCaptureArea,
        cropImg,
        setCropImg,
    ]);

    return (
        <>
            <div className="form-element">
                <div>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenCaptureArea(true)}
                        style={{
                            background: "#031226",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                            borderRadius: 4,
                            color: "#fff",
                            fontWeight: 700,
                        }}
                    >
                        {t(label + "INITIATE-SELECTOR")}
                    </Button>
                </div>
                {openCaptureArea && (
                    <CaptureArea
                        imgCoordinate={{ coordinates: action.fields.completedCrop.value }}
                        setImgCoordinate={setImgCoordinate}
                        action={action}
                        upImg={upImg}
                        setOpenCaptureArea={setOpenCaptureArea}
                        setOpenVariable={setOpenVariable}
                        variables={variables}
                        isGrid={value}
                        isGetText={true}
                    />
                )}
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.GET-TEXT.ASSIGN')}
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    filter="string"
                    isRequired={false}
                />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.ASSIGN')}
                <VariablePicker
                    action={action}
                    inputName="assign"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    filter="boolean"
                />
            </div>
        </>
    );
}

export default GetText;
